module.exports = __webpack_public_path__ + "static/media/logo-innovation.d37870b8.png";